import Vue from 'vue'
import Vuex from 'vuex'
import { GameState, GameModuleClass } from './modules/game'
import { PeerState, PeerModuleClass } from './modules/peer'
import { getModule } from 'vuex-module-decorators'

Vue.use(Vuex)

export interface RootState {
  gameState: GameState;
  peerState: PeerState;
}

const store = new Vuex.Store({
  modules: {
    peer: PeerModuleClass,
    game: GameModuleClass
  }
})

export default store
export const PeerModule = getModule(PeerModuleClass, store)
export const GameModule = getModule(GameModuleClass, store)
